import { render } from "./fake_invoice.vue?vue&type=template&id=278a81a6&scoped=true"
import script from "./fake_invoice.vue?vue&type=script&lang=js"
export * from "./fake_invoice.vue?vue&type=script&lang=js"

import "./fake_invoice.vue?vue&type=style&index=0&id=278a81a6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278a81a6"]])

export default __exports__